import { axiosInstance } from "../axios";

// 历史信息看板 搜索筛选项
export function GetComplaintHistSearchList(params) {
    return axiosInstance.post('/ark/arkservice/history/getMetaData', params);
}

// 历史信息看板
export function getHistoryTickets(params) {
    return axiosInstance.post('/ark/arkservice/customer/getHistoryTickets', params);
}

// 获取治理中台乘客退款详情
export function fetchRefundDetail(params) {
    return axiosInstance.get('/ark/arkservice/compensate/getPassengerTravelRefundDetail', { params });
}

// 获取 司机乘客修改信息表单基本信息
export function fetchGetUidCommon(params) {
    return axiosInstance.get('/ark/arkservice/common/getUidCommon', { params });
}

// 获取可用优惠券
export function fetchGetCouponConfigure(params) {
    return axiosInstance.get('/ark/compensate/getCouponConfigure', { params });
}

// 获取业务类型
export function fetchGetBusinessTypesByPage(params) {
    return axiosInstance.get('/ark/businessType/getBusinessTypesByPage', { params });
}

// 获取补偿风控信息
export function fetchGetCompensateRiskInfo(params) {
    return axiosInstance.get('/ark/compensate/getCompensateRiskInfo', { params })
}

// 车辆 司机 乘客 信息修改===接口待优化
// 获取 车辆修改信息表单基本信息
export function fetchDriverCarList(params) {
    return axiosInstance.get('/ark/driver/getDriverCarList', { params });
}

// 获取 车辆颜色列表
export function fetchDriverCarColorList(params) {
    return axiosInstance.get('/ark/driver/getDriverCarColorList', { params });
}

// 获取 车辆型号列表
export function fetchDriverCarBrandOrColorList(params) {
    return axiosInstance.get('/ark/driver/getDriverCarBrandOrColorList', { params });
}

// 司机 乘客 邮箱解绑
export function fetchUnbindEmail(params) {
    return axiosInstance.post('/ark/passport/unbindEmail', params);
}

// 删除司机账号
export function fetchDelDriverAccount(params) {
    return axiosInstance.post('/ark/driver/delDriverAccount', params)
}

// 乘客角色清除
export function fetchDeleteUser(params) {
    return axiosInstance.post('/ark/passport/deleteUser', params)
}

// 司机头像获取
export function fetchGetPortrait(params) {
    return axiosInstance.get('/ark/driver/getPortrait', { params })
}

// 司机头像清除
export function fetchDelPortrait(params) {
    return axiosInstance.post('/ark/driver/delPortrait', params)
}

// 修改手机号
export function fetchUpdateDriverCell(params) {
    return axiosInstance.post('/ark/passport/updateDriverCell', params)
}
// 修改游离手机号
export function fetchBindDriverCell2Uid(params) {
    return axiosInstance.post('/ark/passport/bindDriverCell2Uid', params)
}

// 司机注册审核信息
// 获取审核任务类型 driverId
export function fetchGetJobList(params) {
    return axiosInstance.get('/ark/driverAudit/getJobList', { params })
}

// 获取审核列表  driverId jobId
export function fetchGetTaskList(params) {
    return axiosInstance.get('/ark/driverAudit/getTaskList', { params })
}

// 获取审核详情  driverId taskId
export function fetchGetTaskDetail(params) {
    return axiosInstance.get('/ark/driverAudit/getTaskDetail', { params })
}

// 提交重审 driverId jobId taskId taskInfo
export function fetchResendAuditTask(params) {
    return axiosInstance.post('/ark/driverAudit/resendAuditTask', params)
}

// 优享业务线城市接口
export function fetchProductCityList(params) {
    return axiosInstance.get('/ark/comfortInfo/getProductCityList', params)
}

// 优享车辆信息接口
export function fetchComfortDataNew(params) {
    return axiosInstance.get('/ark/comfortInfo/getComfortDataNew', { params })
}

// 提交补偿接口
export function submitCompensate(params) {
    return axiosInstance.post('/ark/compensate/submitCompensate', params)
}

// 获取流程卡片信息 /knowledge/knowledge/v3/ark/getDetail
export function fetchGetKnowledgeDetail(params) {
    return axiosInstance.get('/knowledge/knowledge/v3/ark/getDetail', { params })
}

// 知识库反馈提交
export function fetchFeedbackAdd(params) {
    return axiosInstance.post('/optimus/manager/tools/feedback/evaluation/add', params)
}

// 异步消息tab开关
export function getAsyncMsgsABMethod(params, key) {
    // let url = '/ark/apollo/getApolloAbTestGroupNameByKeyPlus?grayKey=' + key
    let url = '/ark/arkservice/apollo/getApolloAbTestGroupNameByKeyPlus?grayKey=' + key
    return axiosInstance.post(url, params)
}

// clipper detail 查看
export function getClipperTicketStatus(params) {
    return axiosInstance.get('/ark/common/getClipperTicketStatus', { params })
    // return Promise.resolve(
    //     {
    //         "status": 0,
    //         "data": {
    //             "SLA_L2_firstClaimDate": 1628152182603,
    //             "aggressor": null,
    //             "SLA_L3_firstClaimDate": 0,
    //             "SLA_L3_closeDate": 0,
    //             "crmTid": "360287970462373109",
    //             "SLA_L2_closeDate": 0,
    //             "victim": null,
    //             "id": 7876214,
    //             "creationDate": 1628152110886,
    //             "category": [
    //                 "SUDDEN_DISEASE"
    //             ],
    //             "status": "T2 Claimed"
    //         },
    //         "error": null,
    //         "errors": null
    //     }
    // )
}

/* 流转 */
// 流转工单组列表
export function fetchGetGroupWithTargetGroupsById(params) {
    return axiosInstance.get('/ark/group/getGroupWithTargetGroupsById', { params })
}
// 优先处理人列表
export function fetchGetGroupUsers(params) {
    return axiosInstance.get('/ark/group/getGroupUsers', { params })
}

// 是否有关单权限
export function fetchGetCloseTicketControlStatus(params) {
    return axiosInstance.get('/ark/common/getCloseTicketControlStatus', { params })
}

// 司机详情
export function getDriverDetailById(params) {
    return axiosInstance.get('/ark/arkservice/common/getUserInfoDetail', { params })
}

// 司机审核注册工具流程图
export function getDriverJobList(params) {
    return axiosInstance.get('/ark/driverAudit/driverInfo/getJobList', { params })
}

// 司机审核注册工具点击流程图的详情
export function getDriverTaskDetail(params) {
    return axiosInstance.get('/ark/driverAudit/driverInfo/getTaskDetail', { params })
}

// 司机列表/车头详情
export function getDriverListInfo(params) {
    return axiosInstance.get('/ark/arkservice/common/getDriverListInfo', { params })
}

// 乘客列表
export function getPassengerListInfo(params) {
    return axiosInstance.get('/ark/arkservice/common/getPassengerListInfo', { params })
}
